import {AfterViewChecked, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {combineLatest, ReplaySubject, Subject} from 'rxjs';
import {BenefitsService} from '../../../../core/service/benefits.service';
import {GetFlexibleBenefitsRequest} from '../../../../core/requests/GetFlexibleBenefitsRequest';
import {filter, finalize, takeUntil} from 'rxjs/operators';
import {GetFlexibleBenefitsResponse} from '../../../../core/responses/GetFlexibleBenefitsResponse';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {BenefitSummaryService} from '../../../../core/service/benefit-summary.service';
import {GetBenefitResponse} from '../../../../core/responses/GetBenefitResponse';
import {FlexibleBenefit} from '../../../../core/models/flexible-benefit';
import {
  AcquisitionType,
  BenefitType,
  BudgetType,
  CompanyTaxDistribution, GetProviderName,
  GIFT_TICKET_CATEGORY_ID,
  PRICING_PLAN_LABEL,
  PricingPlan,
  UnitType,
} from '../../../../core/helpers/constants';
import {NgbCarouselConfig, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GetTaxInfoResponse} from '../../../../core/responses/GetTaxInfoResponse';
import {PaymentService} from '../../../../core/service/payment.service';
import {Photo} from '../../../../core/models/photo';
import {GetPhotosRequest} from '../../../../core/requests/GetPhotosRequest';
import {GetPhotosResponse} from '../../../../core/responses/GetPhotosResponse';
import {AuthenticationService, GoogleAnalyticsService} from '../../../../core/service';
import {BenefitTaxes} from '../../../../core/models/benefit-taxes';
import {User} from '../../../../core/models';
import {ToastrService} from 'ngx-toastr';
import {ShowBenefitComponent} from '../../../shared/show-benefit/show-benefit.component';
import {FixedBenefitDocument} from '../../../../core/models/fixed-benefit-document';
import {BalanceService} from 'app/core/service/balance.service';
import {GetBalanceResponse} from 'app/core/responses/GetBalanceResponse';
import {Balance} from 'app/core/models/balance';
import {CoreTranslationService} from '@core/services/translation.service';
import {OrdersService} from 'app/core/service/orders.service';
import {UserCanOrderResponse} from 'app/core/responses/UserCanOrderReponse';
import {GiftTicketsService} from 'app/core/service/gift-tickets.service';
import {BenefitDetailsService} from '../../../../core/service/benefit-details.service';
import {GetPaymentHistoryResponse} from 'app/core/responses/GetPaymentHistoryResponse';
import {GiftTicketItem} from 'app/core/models/gift-ticket';
import {GetGiftTicketsByBenefitResponse} from 'app/core/responses/GetGiftTicketsByBenefitResponse';
import {SubdomainInfo} from 'app/core/models/subdomain-info';
import {BalanceHistoryRequest} from 'app/core/requests/BalanceHistoryRequest';
import {BalanceHistory} from 'app/core/models/balance-history';
import {GetBalanceHistoryResponse} from 'app/core/responses/GetBalanceHistoryResponse';
import {BenefitHelperService} from 'app/core/service/benefit-helper.service';
import {TaxAndFeesTooltipService} from 'app/core/service/tax-and-fees-tooltip.service';
import {DatePipe, DecimalPipe} from '@angular/common';
import {TaxService} from "../../../../core/service/tax.service";
import {UtilsService} from "../../../../core/service/utils.service";
import {BenefitPaymentType, BudgetAvailabilityType} from "../../../../core/helpers/enums";
import {DashboardService} from "../../../../core/service/dashboard.service";
import {ErrorMessage, OrderErrorPriority} from "../../../shared/error-messages/error-messages.component";
import {AddBeneficiaryComponent} from "../../benefit-summary/add-beneficiary/add-beneficiary.component";
import {BenefitConfirmModalComponent} from "../benefit-confirm-modal/benefit-confirm-modal.component";


@Component({
  selector: 'app-flexible-benefits-info',
  templateUrl: './flexible-benefits-info.component.html',
  styleUrls: ['./flexible-benefits-info.component.scss'],
  providers: [TranslatePipe, DatePipe, DecimalPipe, NgbCarouselConfig]
})
export class FlexibleBenefitsInfoComponent implements OnInit, OnDestroy, AfterViewChecked {
  public cards = [];
  public card = {
    id: 0,
    title: '',
    src: '',
    description: '',
    providerName: '',
    price: 0
  };
  private ngUnsubscribe = new Subject<void>();
  private readonly flexibleBenefitStream = new ReplaySubject<FlexibleBenefit>(1);
  private readonly benefitTaxesStream = new ReplaySubject<BenefitTaxes>(1);
  public flexibleBenefit: FlexibleBenefit;
  public providerId: number;
  public benefitId: number;
  public allBenefits: Array<FlexibleBenefit | any> = [];
  public UNIT_TYPE = UnitType;
  public ACQUISITION_TYPE = AcquisitionType;
  public benefitTaxes: BenefitTaxes;
  public subdomain: string;
  public benefitPhotos: Array<Photo>;
  public selectedQuantity = 1;
  public CompanyTaxDistribution = CompanyTaxDistribution;
  public userCompanyTaxDistribution;
  public maxNumberOfUnits = 9999;
  public minNumberOfUnits = 1;
  public userDashboardInfo: User;
  public userCompanyInfo: SubdomainInfo;
  public userCanOrder: boolean = null;
  // Separate from `userCanOrder`: the generic check above is evaluated assuming
  // budget payment, so it can fail purely due to insufficient *budget* (e.g.
  // subscription RESERVED_AMOUNT_EXCEEDS_BUDGET), which salary payment is immune
  // to. This flag is only populated for benefits that allow salary payment.
  public userCanOrderBySalary: boolean = null;
  public canBeOrdered: boolean;
  // Backend "can't order" reasons come from two independent APIs and are kept
  // in separate fields so neither overwrites the other:
  //   - `cannotOrderMessage`    : set by `canUserOrder` (user-level checks:
  //                               pending order, budget availability, etc.)
  //   - `eventValidationMessage`: set by `verifyCanOrder` (event-level checks:
  //                               ORDER_TICKET limits, CARD_NOT_ALLOWED_DURING_EVENT)
  public cannotOrderMessage: string;
  public eventValidationMessage: string;
  public cannotOrderMessagePeriod: string;
  public selectedBeneficiary = '0';
  private userBalance: Balance;
  private userHistoryBalance: BalanceHistory;
  taxAndFeesTooltipText: string;
  public pendingOrderId: number;
  public pendingSubscriptionId: number;
  public payment: number;
  public events: GiftTicketItem[] = [];
  public closestEventByEndDate: GiftTicketItem = null;
  public companyId: number;
  public ticketOrderLimit = 0;
  public today: Date;
  public startDate: Date;
  public endDate: Date;
  public benefitQuantity: number;
  public hasTransportBudget = false;
  public hasProfessionalDevelopmentBudget = false;
  totalAmountBalance: number;
  public is24PayBenefit = false;
  public selectedCompany24Pay = null;
  public selectedTicket24Pay: string;
  public transport24PayTickets = [];
  public isMealTicketBenefit = false;
  public mealTicketsOptions = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24];
  transformToMilliSecondsOffset = -60000;
  public selectedPaymentType: string = '';
  public userSelectedPaymentType: boolean = false;
  public budgetIsAvailable = true;
  public activeEventName: string | null = null;
  public remainingEventLimit: number | null = null;
  public eventLimitOverflowAmount: number | null = null;
  public cardPaymentBlocked = false;
  public isVerifyingOrder = false;
  public orderButtonDisabled = false;
  public errorMessages: ErrorMessage[] = [];

  @ViewChild('budgetExceededError', { static: true })
  private budgetExceededErrorTpl: TemplateRef<unknown>;

  constructor(
    private modalService: NgbModal,
    private benefitsService: BenefitsService,
    private benefitSummaryService: BenefitSummaryService,
    private authenticationService: AuthenticationService,
    private _coreTranslationService: CoreTranslationService,
    private _route: ActivatedRoute,
    private router: Router,
    private paymentService: PaymentService,
    private _toastrService: ToastrService,
    private translate: TranslatePipe,
    private balanceService: BalanceService,
    private orderService: OrdersService,
    private _giftTicketService: GiftTicketsService,
    private benefitDetailsService: BenefitDetailsService,
    private benefitHelper: BenefitHelperService,
    config: NgbCarouselConfig,
    private taxAndFeesService: TaxAndFeesTooltipService,
    private gAnalyticsService: GoogleAnalyticsService,
    private taxService: TaxService,
    private utilsService: UtilsService,
    private dashboardService: DashboardService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe,
    private translateService: TranslateService
  ) {
    config.wrap = false;
    this.router.events
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((event) => {
        if (event instanceof NavigationEnd || event instanceof NavigationStart) {
          this.minNumberOfUnits = 1;
          this.maxNumberOfUnits = 9999;
          this.selectedQuantity = this.minNumberOfUnits;
          if(this.flexibleBenefit.providerName.includes('24Pay')){
            if ((event as NavigationStart).navigationTrigger === 'popstate') {
              this.router.navigate(['/' + this.subdomain + '/flexible-benefits']);
            }
          }
        }
      });

    this.authenticationService.currentUserInfo.subscribe((x) => {
      if (x) {
        this.companyId = x.companyId;
      }
    });

    this.authenticationService.currentUserCompanyInfo.subscribe((companyInfo) => {
      this.userCompanyInfo = companyInfo;
      this.userCompanyInfo.actualBalanceLoadDay = this.userCompanyInfo.balanceLoadDay;
      if (this.userCompanyInfo.loadDayType === 1) {
        this.utilsService.getNthWorkingDay(this.userCompanyInfo.balanceLoadDay, new Date()).subscribe({
          next: response => {
            this.userCompanyInfo.actualBalanceLoadDay = new Date(response.responseObject).getDate();
            if (this.userCompanyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed) {
              const properties = [
                {
                  value: this.userCompanyInfo.budgetAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.budgetAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.mealTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.mealTicketsAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.tourismTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.tourismTicketsAvailabilityInDays = v
                },
                {
                  value: this.userCompanyInfo.culturalTicketsAvailabilityInDays,
                  setter: (v: number) => this.userCompanyInfo.culturalTicketsAvailabilityInDays = v
                }
              ];

              properties.forEach(p => this.updateWorkingDay(p.value, p.setter));
            }
          }
        });
      }
    });
  }

  /**
   *  Component Lifecycle Methods
   */

  ngOnInit(): void {
    this.authenticationService.currentUserInfo
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((loggedUser: User) => {
        if (loggedUser) {
          const isNewUser = !this.userDashboardInfo || loggedUser.id !== this.userDashboardInfo.id;

          if (isNewUser) {
            this.balanceService.getLastUserBalance(loggedUser.id).subscribe((data: GetBalanceResponse) => {
              this.userBalance = data.responseObject;
              this._route.params.subscribe(() => {
                this.benefitId = parseInt(this._route.snapshot.params.benefitId, 10);
                this.providerId = parseInt(this._route.snapshot.params.providerId, 10);
                this.subdomain = this._route.snapshot.params['subdomain'];
                this.getBenefit();
                this.getFlexibleBenefits();
              });
            });

            const historyRequest: BalanceHistoryRequest = {
              userId: loggedUser.id,
              budgetType: BudgetType.General
            };
            this.balanceService.getLastOrderedTicketsHistoryBalance(loggedUser.id, historyRequest).subscribe((data: GetBalanceHistoryResponse) => {
              this.userHistoryBalance = data.responseObject;
            });
          }

          // Early assignment so callers that need userDashboardInfo before the
          // benefit/taxes finish loading (e.g. canUserOrder) still work.
          this.userDashboardInfo = loggedUser;
        }
      });

    // Reactive recompute of the order button state. Fires whenever any of the
    // three dependencies (current user, benefit, taxes) changes — including the
    // 60s background user-info refresh that previously required polling.
    combineLatest([
      this.authenticationService.currentUserInfo.pipe(filter(u => !!u)),
      this.flexibleBenefitStream,
      this.benefitTaxesStream,
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([user]) => {
        this.userDashboardInfo = user;
        this.getTotalAmount();
        this.refreshOrderState();
      });

    this.translateService.onLangChange
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => this.collectErrorOrInfoMessages());
  }

  public ngAfterViewChecked() {
    if (this.userSelectedPaymentType) {
      return;
    }

    // Don't auto-select until taxes/benefit data is fully loaded to avoid
    // switching to 'card' before canBeOrdered/userCanOrder are determined.
    if (!this.benefitTaxes) {
      return;
    }

    // Don't override while userCanOrder is still loading — it would incorrectly
    // set selectedPaymentType to '' for budget-only benefits, hiding taxes.
    if (this.userCanOrder === null) {
      return;
    }

    // Likewise, wait for the dedicated salary eligibility check before auto-selecting,
    // otherwise a salary-capable benefit could be briefly treated as non-orderable.
    if (this.flexibleBenefit.hasSalaryPaymentAllowed() && this.userCanOrderBySalary === null) {
      return;
    }

    const budgetCanBeUsed = (this.userCanOrder && this.canBeOrdered);

    if(this.flexibleBenefit.benefitPaymentType === BenefitPaymentType.CreditCard){
      this.selectedPaymentType = 'card';
      this.refreshOrderState();
      return;
    }

    // "Plata din salariu": salary is the only option, pre-selected and locked. Outside the
    // ordering window nothing is selectable (salary is blocked during blackout, unlike card).
    if (this.flexibleBenefit.isSalaryPaymentOnly()) {
      this.selectedPaymentType = this.budgetIsAvailable && this.userCanOrderBySalary !== false ? 'salary' : '';
      this.refreshOrderState();
      return;
    }

    // During an active event, always prefer budget payment so the user is never
    // auto-trapped on card (which may be disallowed by the event).
    if (this.activeEventName) {
      if (this.budgetIsAvailable && (this.totalAmountBalance > 0 || this.isSubscriptionBenefit())) {
        this.selectedPaymentType = 'benefitBudget';
      } else if (this.flexibleBenefit.hasCreditCardAllowed()) {
        this.selectedPaymentType = 'card';
      }
      this.refreshOrderState();
      return;
    }

    if (budgetCanBeUsed &&  this.budgetIsAvailable && (this.totalAmountBalance > 0 || this.isSubscriptionBenefit())) {
      if(this.maxNumberOfUnits === 0 && (this.isTicketBenefit() || this.isProductBenefit())){
        this.selectedPaymentType = '';
      } else {
        this.selectedPaymentType = 'benefitBudget';
      }
    } else if (!budgetCanBeUsed && this.flexibleBenefit.hasCreditCardAllowed()) {
      this.selectedPaymentType = 'card';
    } else if (this.flexibleBenefit.hasSalaryPaymentAllowed() && this.userCanOrderBySalary !== false) {
      // Budget cannot cover the order but the benefit allows paying from salary and the
      // ordering window is open — fall back to salary. Salary doesn't depend on
      // `budgetIsAvailable` (that flag tracks the monthly budget period, not salary).
      this.selectedPaymentType = 'salary';
    } else if (!budgetCanBeUsed && !this.flexibleBenefit.hasCreditCardAllowed()) {
      this.selectedPaymentType = '';
    }
    this.refreshOrderState();
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   *  Taxes
   */

  // Taxes - API - Get Taxes for selected benefit

  public getTaxes() {
    if (this.is24PayBenefit && !this.isComplete24PaySelection()) {
      return;
    }
    this.paymentService
      .getTaxForBenefit(
        this.benefitId,
        this.selectedQuantity,
        this.selectedBeneficiary !== '0' && this.flexibleBenefit.categoryId !== GIFT_TICKET_CATEGORY_ID,
        this.get24PayMetaForTaxes(),
        this.selectedPaymentType === 'card',
        this.selectedPaymentType === 'salary'
      ).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data: GetTaxInfoResponse) => {
          this.onGetTaxesSuccess(data);
        },
        error: error => {
          this.onGetTaxesFail(error);
        }
      });
  }

  public onGetTaxesSuccess(data: GetTaxInfoResponse) {
    this.benefitTaxes = {...data.responseObject};
    this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip(this.flexibleBenefit, false);
    this.benefitTaxesStream.next(this.benefitTaxes);
  }

  public onGetTaxesFail(error: HttpErrorResponse) {}

  //  Taxes - helper methods

  getTaxDisplayInfo() {
    if (!this.benefitTaxes) return null;

    // When ordering is blocked by a limit exceeded event error, hide taxes — show only benefit value.
    if (this.isLimitExceeded) {
      return null;
    }

    const totalAmount = this.calculateTotalCost();

    let taxDistributionTypeName =
      this.getTaxDistributionTypeName(this.benefitTaxes.taxDistributionType);

    const isEmployeeWithTax =
      this.benefitTaxes.taxDistributionType === CompanyTaxDistribution.EMPLOYEE &&
      this.benefitTaxes.employeeTaxValue !== 0;

    return {
      // Tax category
      taxCategory: this.flexibleBenefit?.benefitTaxCategory,
      taxDistributionType: this.benefitTaxes.taxDistributionType,
      taxDistributionTypeName: taxDistributionTypeName,
      taxTooltipText: this.taxAndFeesTooltipText,
      shouldShowTaxes: this.shouldShowTaxes(),

      // Values
      taxValue: this.getTaxValue(),
      companyTaxValue: this.benefitTaxes.companyTaxValue,
      employeeTaxValue: this.benefitTaxes.employeeTaxValue,
      camTaxValue: this.benefitTaxes.camTaxValue,
      camTaxPercentage: this.roundTaxPercentage(this.benefitTaxes.camTaxPercentage ?? 0),
      camTaxTooltipKey: this.getCamTaxTooltipKey(this.benefitTaxes.taxDistributionType),
      amountWithVat: this.benefitTaxes.amountWithVat,
      totalAmount: totalAmount,

      // Utils
      shouldShowEmployeeTaxValue: this.benefitTaxes.employeeTaxValue !== 0,
      shouldShowCompanyTaxValue: this.benefitTaxes.companyTaxValue !== 0,
      benefitTaxCategory: this.flexibleBenefit?.benefitTaxCategory,
      isEmployeeWithTax: isEmployeeWithTax,
      showActualBenefitValue: isEmployeeWithTax
    };
  }

  private getTaxDistributionTypeName(distributionType: number): string {
    switch (distributionType) {
      case CompanyTaxDistribution.EMPLOYEE:
        return 'EMPLOYEE';
      case CompanyTaxDistribution.EMPLOYEE_SALARY:
        return 'EMPLOYEE_SALARY';
      case CompanyTaxDistribution.COMPANY:
        return 'COMPANY';
      default:
        return '';
    }
  }

  private getTaxValue(): number {
    const { taxDistributionType, employeeTaxValue, companyTaxValue } = this.benefitTaxes;

    switch (taxDistributionType) {
      case CompanyTaxDistribution.EMPLOYEE_SALARY:
      case CompanyTaxDistribution.EMPLOYEE:
        return employeeTaxValue;
      case CompanyTaxDistribution.COMPANY:
        return companyTaxValue;
      default:
        return 0;
    }
  }

  private shouldShowTaxes() {
    return !this.taxService.hideTaxes(this.benefitTaxes.taxDistributionType, this.companyId);
  }

  /**
   *  24Pay related methods
   */

  public setSelectedTransportCompany(companyId) {
    this.selectedCompany24Pay = companyId;
    for (const company of this.flexibleBenefit.responseTransport24Pay.companies) {
      if (company.code === this.selectedCompany24Pay) {
        this.transport24PayTickets = company.products;
        this.selectedTicket24Pay = '';
        return;
      }
    }
  }

  public setSelectedTransportTicket(ticketId) {
    this.selectedTicket24Pay = ticketId;
    for (const ticket of this.transport24PayTickets) {
      if (ticket.id === this.selectedTicket24Pay) {
        this.verifyCanOrder();
        return;
      }
    }
  }

  private get24PayMetaForTaxes(): string {
    if (!(this.isComplete24PaySelection())) {
      return '-';
    }

    return encodeURIComponent(JSON.stringify({
      Transport24Pay: {
        CompanyId: this.selectedCompany24Pay,
        TicketId: this.selectedTicket24Pay
      }
    }));
  }

  private isComplete24PaySelection() {
    return this.is24PayBenefit && this.selectedCompany24Pay && this.selectedTicket24Pay;
  }

  private isTicketSelectionValid(): boolean {
    return this.selectedCompany24Pay &&
      this.selectedTicket24Pay &&
      this.benefitTaxes.amountWithVat > 0;
  }

  /**
   *  Tickets related methods
   */

  public setCurrentMealTicketsNumber(nrOfTickets){
    let selectedNumberOfTickets = nrOfTickets;
    if (selectedNumberOfTickets > this.maxNumberOfUnits) {
      selectedNumberOfTickets = this.maxNumberOfUnits;
    }

    this.selectedQuantity = selectedNumberOfTickets;
    this.verifyCanOrder();
  }

  private setTicketLimits() {
    if (this.flexibleBenefit.unitType === this.UNIT_TYPE.Units) {
      if (this.flexibleBenefit.benefitTypeId === BenefitType.GiftTicket ||
        this.flexibleBenefit.benefitTypeId === BenefitType.GiftVoucher) {
        // No cap — backend enforces limits via event logic
        this.selectedQuantity = this.minNumberOfUnits;
        return;
      }
      if (this.isTicketBenefit() && this.ticketOrderLimit) {
        this.maxNumberOfUnits = this.ticketOrderLimit / this.flexibleBenefit.price <= this.getRelevantTicketNumber()
          ? this.ticketOrderLimit / this.flexibleBenefit.price : this.getRelevantTicketNumber() - this.getRelevantOrderedTickets();
        if (this.maxNumberOfUnits < 0) {
          this.maxNumberOfUnits = 0;
        }
        if (this.maxNumberOfUnits < this.minNumberOfUnits) {
          this.minNumberOfUnits = this.maxNumberOfUnits;
        }
      } else if (this.isTicketBenefit() && !this.ticketOrderLimit) {
        this.maxNumberOfUnits = this.getRelevantTicketNumber() - this.getRelevantOrderedTickets();
        if (this.maxNumberOfUnits < 0) {
          this.maxNumberOfUnits = 0;
        }
        if (this.maxNumberOfUnits < this.minNumberOfUnits) {
          this.minNumberOfUnits = this.maxNumberOfUnits;
        }
      }

      this.selectedQuantity = this.minNumberOfUnits;
    }
  }

  private getRelevantTicketNumber(): number {
    if (!this.userDashboardInfo || !this.flexibleBenefit) {
      return 0;
    }

    switch (this.flexibleBenefit.benefitTypeId) {
      case BenefitType.MealTicket: return this.userDashboardInfo.numberOfMealTickets;
      case BenefitType.CultureTicket: return this.userDashboardInfo.numberOfCultureTickets;
      case BenefitType.GiftTicket: return this.userDashboardInfo.numberOfGiftTickets;
      case BenefitType.GiftVoucher: return this.userDashboardInfo.numberOfGiftTickets;
      case BenefitType.VacationTicket: return this.userDashboardInfo.numberOfVacationTickets;
      default: return 0;
    }
  }

  private getRelevantOrderedTickets(): number {
    if (!this.userHistoryBalance || !this.flexibleBenefit) {
      return 0;
    }

    switch (this.flexibleBenefit.benefitTypeId) {
      case BenefitType.MealTicket: return this.userHistoryBalance.orderedMealTickets;
      case BenefitType.CultureTicket: return this.userHistoryBalance.orderedCultureTickets;
      case BenefitType.GiftTicket: return this.userHistoryBalance.orderedGiftTickets;
      case BenefitType.GiftVoucher: return this.userHistoryBalance.orderedGiftTickets;
      case BenefitType.VacationTicket: return this.userHistoryBalance.orderedVacationTickets;
      default: return 0;
    }
  }

  /**
   *  Event logic
   */

  public loadActiveEventName() {
    this.dashboardService.getCompanyEvents(this.subdomain)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: response => {
          if (response.responseObject?.length) {
            const today = new Date();
            const activeEvent = response.responseObject.find(e => {
              const end = new Date(e.endDate);
              end.setHours(23, 59, 59, 999);
              return new Date(e.startDate) <= today && today <= end
                && e.benefits.some(b => b.id === this.benefitId);
            });
            // If the user has no gift ticket quota, treat as no event (everything gets normal taxes)
            const hasGiftQuota = (this.userDashboardInfo?.numberOfGiftTickets ?? 0) > 0;
            this.activeEventName = (activeEvent && hasGiftQuota) ? activeEvent.name : null;
          } else {
            this.activeEventName = null;
          }
          this.verifyCanOrder();
        },
        error: () => {
          this.activeEventName = null;
          this.verifyCanOrder();
        }
      });
  }

  get isLimitExceeded(): boolean {
    // Explicit backend error for limit exceeded — used to hide taxes.
    // These keys come from the verifyCanOrder (event-validation) API.
    return this.canBeOrdered === false && (
      !!this.eventValidationMessage?.includes('LIMIT_EXHAUSTED') ||
      !!this.eventValidationMessage?.includes('EXCEEDED_VALUE') ||
      !!this.eventValidationMessage?.includes('ENFORCE_LIMIT_EXCEEDED')
    );
  }

  get isEventLimitConsumed(): boolean {
    // Limit fully consumed (remainingEventLimit = 0) OR hard blocked — used to hide the event badge
    if (this.activeEventName && this.remainingEventLimit === 0) {
      return true;
    }
    return this.isLimitExceeded;
  }

  /**
   *  Benefit data retrieval and manipulation
   */

  //    API call for the main benefit

  public getBenefit() {
    this.benefitSummaryService.getBenefit(this.benefitId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data) =>
          this.onGetBenefitSuccess(data),
        error: (error) => {
          this.onGetBenefitFail(error);
        }
      });
  }

  public onGetBenefitSuccess(data: GetBenefitResponse) {
    this.flexibleBenefit = Object.assign(
      new FlexibleBenefit(),
      data.responseObject
    );
    if (this.flexibleBenefit.providerName.includes('24Pay')) {
      this.is24PayBenefit = true;
    }
    this.flexibleBenefit.providerName = GetProviderName(this.flexibleBenefit.providerName, this.subdomain);
    this.isMealTicketBenefit = this.flexibleBenefit.benefitTypeId === BenefitType.MealTicket;
    this.getByBenefit();
    this.getBenefitPhotos();
    this.selectedPaymentType = this.getPaymentType(this.flexibleBenefit.benefitPaymentType);
    this.canUserOrder();
    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'view_item', {
      value: this.flexibleBenefit.price,
      currency: 'RON',
      items: [
        {
          item_id: this.flexibleBenefit.id,
          item_sku: this.flexibleBenefit.sku,
          item_name: this.flexibleBenefit.name,
          item_category: this.flexibleBenefit.categoryName,
          item_category_id: this.flexibleBenefit.categoryId,
          item_brand: this.flexibleBenefit.providerName,
          price: this.flexibleBenefit.price,
          affiliation: this.flexibleBenefit.providerName,
          vat_included: this.flexibleBenefit.includesVat,
          vat_percentage: this.flexibleBenefit.vatPercentage,
          card_payment_allowed: this.flexibleBenefit.hasCreditCardAllowed(),
          tax_type: this.flexibleBenefit.benefitTaxCategory,
          supplier_id: this.flexibleBenefit.providerId,
          benefit_Type: this.flexibleBenefit.benefitTypeId,
        }
      ]
    });

    // Notify the reactive order-state pipeline that the benefit is loaded.
    this.flexibleBenefitStream.next(this.flexibleBenefit);
  }

  public onGetBenefitFail(error: any) {
    error.messages.forEach((errorItem) => {
      this._toastrService.error(
        this.t(errorItem),
        this.t('ERROR'),
        { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
      );
    });
  }

  public getByBenefit(): void {
    this.today = new Date(Date.now());
    this.benefitId = this.flexibleBenefit.id;
    const data =
      {
        'companyId': this.companyId,
        'benefitId': this.benefitId
      };
    this._giftTicketService.getByBenefit(data).subscribe(
      (tdata: GetGiftTicketsByBenefitResponse) => {
        this.events = tdata.responseObject;
        if (this.events && this.events.length > 0) {
          this.ticketOrderLimit = 0;
          this.events.forEach(element => {
            if (new Date(element.startDate) <= this.today
              && this.today <= new Date(element.endDate)) {
              this.ticketOrderLimit += element.orderLimit;
            }
          });
          // Sort by the absolute difference in ms between dates.
          this.closestEventByEndDate = tdata.responseObject
            .sort((a, b) => (
              Math.abs(new Date(a.endDate).getTime() - this.today.getTime()) -
              Math.abs(new Date(b.endDate).getTime() - this.today.getTime()))
            )[0];
        }
        this.setTicketLimits();
        this.setProductBenefitsLimit();
        this.loadActiveEventName();
      }
    );
  }

  //    API call for flexible benefits

  public getFlexibleBenefits() {
    const params: GetFlexibleBenefitsRequest = {
      paginationCriteria: {
        start: 0,
        limit: 150
      },
      companyId: this.companyId,
      providerId: this.providerId
    };
    this.benefitsService.getUserFlexibleBenefits(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: data => {
          this.onGetFlexibleBenefitsSuccess(data);
        },
        error: error => {
          this.onFlexibleBenefitsFail(error);
        }
      });
  }

  public onGetFlexibleBenefitsSuccess(data: GetFlexibleBenefitsResponse) {
    this.allBenefits = data.responseObject.data;
    this.setBenefits();
  }

  public onFlexibleBenefitsFail(error: HttpErrorResponse) {}

  //    API call for benefit photos

  public getBenefitPhotos() {
    const params: GetPhotosRequest = {
      paginationCriteria: {
        start: 0,
        limit: 4
      },
      benefitId: this.benefitId
    };
    this.benefitsService.getBenefitPhotos(params)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        data => {
          this.onGetBenefitPhotosSuccess(data);
        },
        error => {
          this.onGetBenefitPhotosFail(error);
        });
  }

  public onGetBenefitPhotosSuccess(data: GetPhotosResponse) {
    this.benefitPhotos = data.responseObject.data;
    if (this.benefitPhotos.length === 0) {
      this.benefitPhotos.push({
        name: 'Default',
        pictureUrl: '',
        benefitName: this.flexibleBenefit.name,
        photoId: 0
      });
    }
  }

  public onGetBenefitPhotosFail(error: HttpErrorResponse) {}

  //    Benefit object handlers

  private quantityChangeTimer: any = null;

  public quantityChanged($event) {
    this.selectedQuantity = $event;
    if (this.quantityChangeTimer) {
      clearTimeout(this.quantityChangeTimer);
    }
    this.quantityChangeTimer = setTimeout(() => {
      this.verifyCanOrder();
    }, 400);
  }

  public setBenefits() {
    if (this.allBenefits.length > 0) {
      this.cards = this.allBenefits
        .filter(e => e.id !== this.benefitId)
        .map((benefit: FlexibleBenefit) => this.benefitHelper.mapBenefitToDisplayPrice(benefit));
    }
  }

  private setProductBenefitsLimit() {
    if (this.flexibleBenefit.unitType === this.UNIT_TYPE.Units) {
      if (this.isProductBenefit()) {
        this.benefitQuantity = this.flexibleBenefit.quantity;
        this.maxNumberOfUnits = this.benefitQuantity;
        if (this.maxNumberOfUnits < 0) {
          this.maxNumberOfUnits = 0;
        }
        if (this.maxNumberOfUnits < this.minNumberOfUnits) {
          this.minNumberOfUnits = this.maxNumberOfUnits;
        }
      }
    }
  }

  /**
   *  Flexible benefit type checks
   */

  isTicketBenefit(): boolean {
    const ticketBenefitTypes = [
      BenefitType.MealTicket,
      BenefitType.GiftTicket,
      BenefitType.CultureTicket,
      BenefitType.VacationTicket
    ];

    return ticketBenefitTypes.includes(this.flexibleBenefit?.benefitTypeId);
  }

  isProductBenefit(): boolean {
    return this.flexibleBenefit?.benefitTypeId === BenefitType.Product;
  }

  private isSubscriptionBenefit(): boolean {
    return this.flexibleBenefit?.acquisitionType === AcquisitionType.Subscription;
  }

  get isGiftTypeBenefit(): boolean {
    return this.flexibleBenefit?.benefitTypeId === BenefitType.GiftTicket;
  }

  /**
   *  Document handling methods
   */

  public showDocument(document: FixedBenefitDocument) {
    // TODO make this section along with the UI a componenet so it can be reused
    const modalRef = this.modalService.open(ShowBenefitComponent, {
      centered: true,
      backdrop: 'static'
    });
    modalRef.componentInstance.document = document;
    modalRef.componentInstance.type = 'fixed';
  }

  /**
   *  Budget, cost and payment related methods
   */

  private isBudgetSufficient(): boolean {
    return this.calculateTotalCost() <= this.userDashboardInfo.totalAmount;
  }

  public checkBudgetsAvailability(): boolean {
    if (this.flexibleBenefit.acquisitionType === AcquisitionType.Subscription && this.userCanOrder) {
      return true;
    }
    return this.calculateTotalCost() <= this.totalAmountBalance;
  }

  private calculateTotalCost(): number {
    return this.taxService.getAmountToPayFromBenefitTaxes(this.benefitTaxes, this.userDashboardInfo.companyTaxDistribution);
  }

  private getTotalAmount() {
    this.totalAmountBalance = this.userDashboardInfo.totalAmount;
    if (this.userCompanyInfo?.hasTransportBudget && this.flexibleBenefit.benefitTypeId === BenefitType.Transport) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountTransport;
    }

    if (this.userCompanyInfo?.hasProfessionalDevelopmentBudget && this.flexibleBenefit.benefitTypeId === BenefitType.ProfessionalDevelopment) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountProfessionalDevelopment;
    }

    if (this.userCompanyInfo?.hasCashbackBudget) {
      this.totalAmountBalance += this.userDashboardInfo.totalAmountCashback;
    }
  }

  private getPaymentType(paymentType: BenefitPaymentType) {
    switch (paymentType) {
      case BenefitPaymentType.CreditCard:
        return 'card';
      case BenefitPaymentType.BudgetAndCreditCard:
        return 'benefitBudget';
      case BenefitPaymentType.Budget:
        return 'benefitBudget';
      case BenefitPaymentType.Salary:
        return 'salary';
      case BenefitPaymentType.BudgetAndSalary:
        // Budget is the default option; salary must be explicitly selected.
        return 'benefitBudget';
    }
  }

  onPaymentTypeChange() {
    this.userSelectedPaymentType = true;
    if (this.activeEventName) {
      // Async verification — its finalize() block refreshes the order state
      // once the API resolves; the loading spinner masks the UI in the meantime.
      this.verifyCanOrder();
      return;
    }
    // No verification round-trip on this path — recompute synchronously so the
    // error list and order button reflect the new selectedPaymentType
    // (case 3 of collectErrorOrInfoMessages depends on it).
    this.refreshOrderState();
    this.getTaxes();
  }

  shouldDisplayBenefitPayment(): boolean {
    if(this.flexibleBenefit.benefitPaymentType === BenefitPaymentType.CreditCard){
      return false;
    }

    // "Plata din salariu" benefits are paid exclusively from salary — no budget option.
    if (this.flexibleBenefit.isSalaryPaymentOnly()) {
      return false;
    }

    // During an active event, canBeOrdered=false only means card is disallowed —
    // the budget option should still be shown as long as the user can order and has budget.
    const canOrder = this.activeEventName
      ? this.userCanOrder !== false
      : (this.userCanOrder && this.canBeOrdered);

    if(this.budgetIsAvailable && canOrder &&
      (this.totalAmountBalance > 0 || this.isSubscriptionBenefit())) {
      if (this.isProductBenefit() && this.maxNumberOfUnits === 0 ||
        this.isTicketBenefit() && this.maxNumberOfUnits === 0) {
        return false;
      }

      return true;
    }

    return false;
  }

  shouldDisplaySalaryPayment(): boolean {
    if (!this.flexibleBenefit.hasSalaryPaymentAllowed()) {
      return false;
    }

    // Salary payment follows the ordering window (unlike card, it IS blocked in the
    // closed period), but does not depend on the available budget balance, so
    // `budgetIsAvailable` (which tracks the monthly budget period, not salary) must
    // not gate it here. It relies on `userCanOrderBySalary` (a dedicated check made
    // with payWithSalaryAllowed=true) instead of the generic `userCanOrder`, since the
    // latter can be false purely due to insufficient *budget* (e.g. subscription
    // RESERVED_AMOUNT_EXCEEDS_BUDGET), which salary payment is immune to.
    const canOrder = this.activeEventName
      ? this.userCanOrderBySalary !== false
      : (this.userCanOrderBySalary && this.canBeOrdered);

    if (canOrder) {
      if (this.isProductBenefit() && this.maxNumberOfUnits === 0 ||
        this.isTicketBenefit() && this.maxNumberOfUnits === 0) {
        return false;
      }

      return true;
    }

    return false;
  }

  /**
   * Amount the card has to cover when the event budget is overflown.
   * Mirrors the inline expression `cardPaymentAmount - totalAmountCashback`
   * that several error conditions and the order button rely on.
   */
  private get cardOverflowAmount(): number {
    return (this.benefitTaxes?.cardPaymentAmount ?? 0) -
      (this.userDashboardInfo?.totalAmountCashback ?? 0);
  }

  /**
   *  Order placement verification
   */

  private canUserOrder() {
    this.orderService
      .canUserOrder(
        this.userDashboardInfo.id,
        this.benefitId,
        this.selectedPaymentType === 'card'
      ).subscribe({
        next: (response: UserCanOrderResponse) => {
          this.onUserCanOrderSucces(response);
        },
        error: (error: any) => {
          this.onUserCanOrderFail(error);
        }
      });

    // Salary payment is immune to budget-related rejections, so its eligibility
    // must be checked independently of the generic (budget-assuming) call above.
    //
    // This can't be collapsed into a single call by passing both flags together
    // (e.g. payWithCard=selectedPaymentType==='card', payWithSalaryAllowed=true):
    // the backend's canOrder/message pair represents one evaluated code path, not
    // two independent ones. For a BudgetAndSalary benefit paid from budget, sending
    // payWithSalaryAllowed=true would make the backend skip the subscription
    // budget/limit check (it's bypassed whenever payWithSalaryAllowed is true),
    // incorrectly reporting the budget path as eligible even when it isn't. The two
    // intents ("can the user pay via budget?" vs "can the user pay via salary?")
    // need their own request/response round-trip to each get a correct answer.
    if (this.flexibleBenefit.hasSalaryPaymentAllowed()) {
      this.orderService
        .canUserOrder(
          this.userDashboardInfo.id,
          this.benefitId,
          false,
          true
        ).subscribe({
          next: (response: UserCanOrderResponse) => {
            this.userCanOrderBySalary = response.responseObject.canOrder;
            this.refreshOrderState();
          },
          error: () => {
            this.userCanOrderBySalary = false;
          }
        });
    }
  }

  private onUserCanOrderSucces(response: UserCanOrderResponse) {
    this.userCanOrder = response.responseObject.canOrder;
    this.pendingOrderId = response.responseObject.pendingOrderId;
    this.pendingSubscriptionId = response.responseObject.pendingSubscriptionId;
    if (response.responseObject.message) {
      this.cannotOrderMessage = response.responseObject.message;
      const cannotOrderReasons = {
        ['MEAL_TICKETS_BUDGET_NOT_AVAILABLE']: this.userCompanyInfo.mealTicketsAvailabilityInDays,
        ['TOURSIM_TICKETS_BUDGET_NOT_AVAILABLE']: this.userCompanyInfo.tourismTicketsAvailabilityInDays,
        ['CULTURAL_TICKETS_BUDGET_NOT_AVAILABLE']: this.userCompanyInfo.culturalTicketsAvailabilityInDays,
        ['BUDGET_NOT_AVAILABLE']: this.userCompanyInfo.budgetAvailabilityInDays
      };
      for (const [key, days] of Object.entries(cannotOrderReasons)) {
        if (this.cannotOrderMessage.includes(key)) {
          this.computeCannotOrderMessagePeriod(days);
          this.budgetIsAvailable = false;
          // If a particular budget is not available
          // (ex. MEAL_TICKETS_BUDGET_NOT_AVAILABLE), then the period will be
          // calculated for BUDGET_NOT_AVAILABLE in the end which is incorrect
          // Thus, we break the loop if we find a match to avoid overriding the message with a more generic one
          break;
        }
      }
    }
    // this.userCanOrder is updated => check for any potential error
    this.refreshOrderState();
  }

  private onUserCanOrderFail(error: any) {}

  private verifyCanOrder() {
    this.canBeOrdered = true;
    // `cannotOrderMessage` should be updated only by the canUserOrder
    this.eventValidationMessage = null;
    this.cardPaymentBlocked = false;
    this.remainingEventLimit = null;
    this.eventLimitOverflowAmount = null;
    this.isVerifyingOrder = true;

    // If the benefit is not part of an active event, skip the event-validation API call
    if (!this.activeEventName) {
      this.getTaxes();
      this.isVerifyingOrder = false;
      // multiple variables are updated => check for errors
      this.refreshOrderState();
      return;
    }

    const data = {
      'benefitId': this.benefitId,
      'quantity': this.selectedQuantity,
      'beneficiaries': [],
      'payWithCardOnly': this.selectedPaymentType === 'card',
    };

    this._giftTicketService.verifyCanOrder(data).pipe(
      finalize(() => {
        this.isVerifyingOrder = false;
        // multiple variables are updated => check for errors
        this.refreshOrderState();
      })
    ).subscribe({
      next: (response) => {
        this.remainingEventLimit = response?.responseObject?.remainingEventLimit ?? null;
        this.eventLimitOverflowAmount = response?.responseObject?.eventLimitOverflowAmount ?? null;
        const taxModel = response?.responseObject?.taxModel;
        if (this.remainingEventLimit !== null) {
          if (taxModel) {
            const hasNoTaxes = this.taxService.getTotalTaxAmount(taxModel) === 0;
            this.onGetTaxesSuccess({ responseObject: taxModel } as GetTaxInfoResponse);
            this.taxAndFeesTooltipText = this.taxAndFeesService.setTaxAndFeesTooltip(
              this.flexibleBenefit,
              hasNoTaxes,
              true
            );
          }
        } else {
          this.getTaxes();
        }
      },
      error: (error: any) => {
        if (error.messages?.length) {
          const message = error.messages[0];
          if (message.includes('CARD_NOT_ALLOWED_DURING_EVENT') &&
            this.isGiftTypeBenefit &&
            !this.flexibleBenefit.hasCreditCardAllowed()) {
            // Budget-only benefit: card restriction is irrelevant, let normal budget exceeded UI handle it
          } else {
            this.canBeOrdered = false;
            this.eventValidationMessage = message;
            if (message.includes('CARD_NOT_ALLOWED_DURING_EVENT')) {
              this.cardPaymentBlocked = true;
            }
          }
        }
        this.getTaxes();
      }
    });
  }

  /**
   * True when the order is (or will be) paid from salary — either explicitly selected,
   * or mandatory for "Plata din salariu" (salary-only) benefits. Shared by every check
   * below that needs to pick between the generic (budget-assuming) `userCanOrder` and
   * the dedicated, budget-immune `userCanOrderBySalary`.
   */
  private get isPaidFromSalary(): boolean {
    return this.selectedPaymentType === 'salary' || this.flexibleBenefit.isSalaryPaymentOnly();
  }

  /**
   * Eligibility flag matching the currently selected payment type. Salary payment is
   * checked via a dedicated eligibility flag (immune to budget rejections) instead of
   * the generic, budget-assuming `userCanOrder`.
   */
  private get canOrderForSelectedPaymentType(): boolean {
    return this.isPaidFromSalary ? this.userCanOrderBySalary : this.userCanOrder;
  }

  get isOrderButtonDisabled(): boolean {
    return !this.canOrderForSelectedPaymentType ||
      !this.isTicketSelectionValid() ||
      !this.isBudgetSufficient() ||
      !this.canBeOrdered;
  }

  private isOrderingProhibited() {
    const cardPaymentCanBypassBudgetAvailability =
      this.flexibleBenefit.hasCreditCardAllowed() &&
      this.selectedPaymentType === 'card' &&
      !this.budgetIsAvailable &&
      this.cannotOrderMessage?.includes('BUDGET_NOT_AVAILABLE');
    const isLitePlanWithoutCardSupport =
      this.userCompanyInfo?.pricingPlan === PricingPlan.LITE &&
      !this.flexibleBenefit.hasCreditCardAllowed();

    // GiftTicket in active event — block when card is needed but card not allowed (budget-only).
    // When card IS allowed, the difference is covered by card — don't block.
    if (this.activeEventName && this.isGiftTypeBenefit && !this.flexibleBenefit.hasCreditCardAllowed()) {
      const cashback = this.userDashboardInfo?.totalAmountCashback ?? 0;
      const effectiveCardAmount = Math.max(0, (this.benefitTaxes?.cardPaymentAmount ?? 0) - cashback);
      if (this.cardPaymentBlocked || effectiveCardAmount > 0) {
        return true;
      }
    }

    const isOrderingProhibitedFlag =
      (this.activeEventName && this.isGiftTypeBenefit && this.cardPaymentBlocked) ||
      !this.canBeOrdered ||
      this.pendingOrderId ||
      // only allowed during budget availability — doesn't apply to salary payment,
      // which never depends on the (budget-period) `budgetIsAvailable` flag.
      (!this.budgetIsAvailable && !cardPaymentCanBypassBudgetAvailability && !this.isPaidFromSalary) ||
      // LITE plan can proceed only when card payment is available for the benefit.
      isLitePlanWithoutCardSupport ||
      // if the server says user can't order benefit (or ticket), block
      // Note: null means still loading, so don't block in that case
      (this.canOrderForSelectedPaymentType === false && !cardPaymentCanBypassBudgetAvailability) ||
      this.isTicketBenefit() && this.maxNumberOfUnits === 0;

    if (isOrderingProhibitedFlag) return true;
    // always allowed if card payment is allowed for this benefit
    if (this.flexibleBenefit.hasCreditCardAllowed()) return false;
    // paying from salary doesn't touch the budget — budget sufficiency is irrelevant
    if (this.isPaidFromSalary) return false;


    // check if the user has enough total budget to cover the item price (including tax)
    var amountToPay = this.taxService.getAmountToPayFromBenefitTaxes(this.benefitTaxes, this.userDashboardInfo.companyTaxDistribution);
    var availableUserBudget = (this.userDashboardInfo?.totalAmount ?? 0);
    if (this.flexibleBenefit.benefitTypeId === BenefitType.Transport && this.userCompanyInfo.hasTransportBudget) {
      availableUserBudget += this.userDashboardInfo?.totalAmountTransport ?? 0
    } else if (this.flexibleBenefit.benefitTypeId === BenefitType.ProfessionalDevelopment && this.userCompanyInfo.hasProfessionalDevelopmentBudget) {
      availableUserBudget += this.userDashboardInfo?.totalAmountProfessionalDevelopment ?? 0;
    }

    return availableUserBudget < amountToPay && this.flexibleBenefit.acquisitionType !== AcquisitionType.Subscription;
  }

  /**
   * Recomputes derived UI state (order button + error messages) in one place
   * so all triggers (reactive stream, canUserOrder response, verifyCanOrder
   * callbacks) keep both in sync.
   */
  private refreshOrderState() {
    this.orderButtonDisabled = this.isOrderingProhibited();
    this.collectErrorOrInfoMessages();
  }

  private collectErrorOrInfoMessages() {
    const messages: ErrorMessage[] = [];
    const benefit = this.flexibleBenefit;
    const taxes = this.benefitTaxes;
    const company = this.userCompanyInfo;
    const ndBtnErrClass = 'nd-btn not-eligible-warning font-small-3 mt-2';
    const ndBtnInfoClass = 'nd-btn text-warning font-small-3 mt-2';

    // Named predicates — derived once for readability and re-use across cases.
    const noPaymentByCardAllowed      = !!(benefit && !benefit.hasCreditCardAllowed());
    const isPaidFromSalary            = this.isPaidFromSalary;
    // The generic (budget-assuming) `userCanOrder` can be false purely because of a
    // budget shortfall that salary payment is immune to — don't surface those
    // budget-centric messages when salary payment was separately confirmed eligible.
    const salaryOverridesGenericBlock = isPaidFromSalary && this.userCanOrderBySalary !== false;
    const isPendingOrder              = this.userCanOrder === false && !!this.pendingOrderId;
    const cannotOrderAndNoPendingOrder= this.userCanOrder === false && !this.pendingOrderId && !salaryOverridesGenericBlock;
    const hasOverflow                 = (this.eventLimitOverflowAmount ?? 0) > 0;
    const cardCoversOverflow          = !!benefit?.hasCreditCardAllowed() && this.cardOverflowAmount > 0;
    const cardPaymentAvailable        = !!benefit?.hasCreditCardAllowed();

    // 1) LITE plan: budget cannot be used for benefits that don't allow card payment.
    if (noPaymentByCardAllowed && company?.pricingPlan === PricingPlan.LITE) {
      messages.push({
        text: 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.NO_VALID_BUDGET',
        className: ndBtnErrClass,
        priority: OrderErrorPriority.BLOCKED
      });
    }

    // 2) Pending / refused order — clickable navigation to the order details.
    if (isPendingOrder) {
      messages.push({
        text: `${this.t(this.cannotOrderMessage)} (#${this.pendingOrderId})`,
        onClick: () => this.goToPaymentPendingOrRefused(),
        className: ndBtnErrClass,
        priority: OrderErrorPriority.ACTION_REQUIRED
      });
    }

    // 3) Cannot order, budget availability expired and not paying by card.
    if (cannotOrderAndNoPendingOrder && !this.budgetIsAvailable &&
      !cardPaymentAvailable && this.cannotOrderMessagePeriod) {
      messages.push({
        text: this.cannotOrderMessage,
        translationParams: { period: this.cannotOrderMessagePeriod },
        className: ndBtnErrClass,
        priority: OrderErrorPriority.BLOCKED
      });
    }

    // 4) Cannot order, budget available — order cannot proceed further
    // due to another received message from backend
    if (cannotOrderAndNoPendingOrder && this.budgetIsAvailable &&
      !cardPaymentAvailable && this.cannotOrderMessage) {
      messages.push({
        text: this.cannotOrderMessage,
        className: ndBtnErrClass,
        priority: OrderErrorPriority.BLOCKED
      });
    }

    // 5) Budget unavailable, payment by card not allowed.
    // This case seems to be a duplicate of 3)
    // At this moment the backend returns false for the userCanOrder false for any error message
    // budgetIsAvailable is false for any *BUDGET_NOT_AVAILABLE error message received from BE
    // TODO: eliminate this case in the future
      if (this.userCanOrder !== false && !this.budgetIsAvailable &&
      noPaymentByCardAllowed && this.cannotOrderMessagePeriod) {
      messages.push({
        text: 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE',
        translationParams: { period: this.cannotOrderMessagePeriod },
        className: ndBtnErrClass,
        priority: OrderErrorPriority.BUDGET_TIMING
      });
    }

    // 6) canBeOrdered === false (from event-validation) — 3 mutually-exclusive sub-cases.
    //    Reads `eventValidationMessage` (set only by verifyCanOrder), so this case
    //    can never duplicate cases 2/3/4 which read `cannotOrderMessage` (set only
    //    by canUserOrder). The two backend sources live in separate fields.
    if (this.canBeOrdered === false && this.eventValidationMessage) {
      const msg = this.eventValidationMessage;
      if (msg.includes('CARD_NOT_ALLOWED_DURING_EVENT')) {
        messages.push({ text: 'ORDER_TICKET.CARD_NOT_ALLOWED_DURING_EVENT_NO_AMOUNT', priority: OrderErrorPriority.EVENT_RULE });
      } else if (msg.includes('ORDER_TICKET')) {
        messages.push({ text: msg, priority: OrderErrorPriority.EVENT_RULE });
      } else {
        // For the moment
        // verifyCanOrder from BE returns errors of type ORDER_TICKET.* => this branch never reached
        messages.push({
          text: 'FLEXIBLE_FIXED_BENEFITS.THIS_BENEFIT_CAN_BE_ORDERED_BETWEEN_STRICT',
          translationParams: {
            startDate: this.datePipe.transform(this.closestEventByEndDate?.startDate, 'dd/MM/yyyy'),
            endDate:   this.datePipe.transform(this.closestEventByEndDate?.endDate,   'dd/MM/yyyy')
          },
          priority: OrderErrorPriority.EVENT_RULE
        });
      }
    }

    // 7-8) Non-GiftTicket event overflow — wording depends on whether the card
    //      covers the overflow. The two sub-cases are mutually exclusive on
    //      `cardCoversOverflow` (NOT on `cardOverflowAmount > 0` alone — case 7
    //      must still fire when cardOverflow ≤ 0, e.g. when cashback offsets it).
    if (!this.isVerifyingOrder && hasOverflow && !this.isGiftTypeBenefit) {
      if (!cardCoversOverflow && taxes && this.taxService.getTotalTaxAmount(taxes) > 0) {
        // 7) Card doesn't cover the overflow — taxes apply on the difference.
        messages.push({
          text: 'ORDER_TICKET.EVENT_LIMIT_OVERFLOW',
          translationParams: { overflow: this.eventLimitOverflowAmount },
          className: ndBtnInfoClass,
          priority: OrderErrorPriority.COST_INFO
        });
      } else if (cardCoversOverflow) {
        // 8) Card covers the overflow — tell the user the card-charge amount.
        messages.push({
          text: 'ORDER_TICKET.EVENT_LIMIT_OVERFLOW_CARD_AMOUNT',
          translationParams: { amount: this.decimalPipe.transform(this.cardOverflowAmount, '1.2-2') },
          className: ndBtnInfoClass,
          priority: OrderErrorPriority.COST_INFO
        });
      }
    }

    // 9-10) Per-user quota consumed (ticket OR product — mutually exclusive).
    //       Note: case 10 (Product) cannot currently be reproduced in the UI
    //       since isBusinessProduct benefits aren't displayed — kept for parity.
    if (this.maxNumberOfUnits === 0 && (this.isTicketBenefit() || this.isProductBenefit())) {
      messages.push({
        text: this.isTicketBenefit()
          ? 'FLEXIBLE_FIXED_BENEFITS.USER_TICKET_LIMIT_EXCEDEED'
          : 'FLEXIBLE_FIXED_BENEFITS.PRODUCT_QUANTITY_LIMIT_EXCEDEED',
        priority: OrderErrorPriority.LIMIT_REACHED
      });
    }

    // 11) Insufficient budget — uses a bespoke template (icon + tooltip).
    //     Skipped when the order is paid from salary: the budget balance is not used at all,
    //     so a budget-exceeded warning would be wrong (matches isOrderingProhibited).
    if (!this.isVerifyingOrder && noPaymentByCardAllowed && !isPaidFromSalary &&
      !this.checkBudgetsAvailability() && this.canBeOrdered !== false && !hasOverflow) {
      messages.push({
        template: this.budgetExceededErrorTpl,
        priority: OrderErrorPriority.BUDGET_INSUFFICIENT
      });
    }

    // Sort by priority — lower value renders first.
    // Untagged entries fall to the bottom.
    this.errorMessages = messages.sort(
      (a, b) =>
        (a.priority ?? Number.MAX_SAFE_INTEGER) - (b.priority ?? Number.MAX_SAFE_INTEGER)
    );
  }

  getNoBudgetAvailableToolTip() {
    if(this.flexibleBenefit.benefitPaymentType === BenefitPaymentType.CreditCard){
      return 'FLEXIBLE_FIXED_BENEFITS.ONLY_CARD_PAYMENT_ALLOWED';
    }

    if (this.pendingOrderId) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT_PENDING_OR_REFUSED';
    }

    // Salary is still selectable, so "you cannot order" would be wrong here —
    // point the user at the payment option that does work.
    if (this.shouldDisplaySalaryPayment()) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE_SALARY_OK';
    }

    if (this.flexibleBenefit.hasCreditCardAllowed() && !this.budgetIsAvailable) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE_CARD_AVAILABLE';
    }

    if (this.cannotOrderMessagePeriod) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE';
    }

    if (this.flexibleBenefit.hasCreditCardAllowed()) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE_CARD_OK';
    } else if (this.totalAmountBalance === 0) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE_NO_FUNDS';
    }

    return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE_SIMPLE';
  }

  /**
   * Tooltip for the disabled "pay from salary" row. Salary payment never depends on the
   * budget balance, so the budget wording (insufficient funds) must not be reused here.
   */
  getNoSalaryAvailableToolTip() {
    if (this.pendingOrderId) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT_PENDING_OR_REFUSED';
    }

    if (this.cannotOrderMessagePeriod) {
      return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.BUDGET_NOT_AVAILABLE';
    }

    return 'FLEXIBLE_FIXED_BENEFITS.PAYMENT.SALARY_NOT_AVAILABLE_SIMPLE';
  }

  private computeCannotOrderMessagePeriod(availabilityInDays: number) {
    const endDay: number = this.userCompanyInfo.budgetAvailabilityType === BudgetAvailabilityType.Fixed ?
      availabilityInDays :
      this.userCompanyInfo.actualBalanceLoadDay + availabilityInDays - 1;
    this.cannotOrderMessagePeriod = `${this.userCompanyInfo.actualBalanceLoadDay} - ${endDay}`;
  }

  /**
   *  Redirect methods
   */

  public goToOtherOffer(benefitId: number) {
    this.router.navigate(['/' + this.subdomain + '/flexible-benefits-info/' + this.providerId + '/' + benefitId]);
  }

  public goToPaymentPendingOrRefused() {
    // If there's a pending subscription, navigate directly to subscription details
    if (this.pendingSubscriptionId) {
      this.router.navigate(['/' + this.subdomain + '/benefit-details/subscription/' + this.pendingSubscriptionId + '/']);
      return;
    }

    // Otherwise, navigate to order details
    this.benefitSummaryService.getOrderPayment(this.pendingOrderId).subscribe(
      (data: GetPaymentHistoryResponse) => {
        this.benefitDetailsService.editPaymentHistory(data.responseObject);
        if (!this.userCanOrder) {
          this.router.navigate(['/' + this.subdomain + '/benefit-details/order/' + this.pendingOrderId + '/']);
        }
      });
  }

  public goToSummary() {
    if (!this.canUserOrder) {
      return;
    }
    this.gAnalyticsService.addGeneralEventsAnalytics('event', 'add_to_cart', {
      value: this.flexibleBenefit.price * this.selectedQuantity,
      currency: 'RON',
      items: [
        {
          item_id: this.flexibleBenefit.id,
          item_sku: this.flexibleBenefit.sku,
          item_name: this.flexibleBenefit.name,
          item_category: this.flexibleBenefit.categoryName,
          item_category_id: this.flexibleBenefit.categoryId,
          item_brand: this.flexibleBenefit.providerName,
          price: this.flexibleBenefit.price,
          quantity: this.selectedQuantity,
          affiliation: this.flexibleBenefit.providerName,
          vat_included: this.flexibleBenefit.includesVat,
          vat_percentage: this.flexibleBenefit.vatPercentage,
          card_payment_allowed: this.flexibleBenefit.hasCreditCardAllowed(),
          tax_type: this.flexibleBenefit.benefitTaxCategory,
          supplier_id: this.flexibleBenefit.providerId,
          benefit_Type: this.flexibleBenefit.benefitTypeId,
        }
      ]
    });

    if (this.flexibleBenefit.benefitTypeId === BenefitType.Insurance) {
      const modalRef = this.modalService.open(BenefitConfirmModalComponent, {
        centered: true,
        backdrop: 'static',
      });

      modalRef.componentInstance.flexibleBenefit = this.flexibleBenefit;
      return;
    }

    if (this.userDashboardInfo.totalAmount >= 0) {
      this.router.navigate(['/' + this.subdomain + '/benefit-summary/' +
      this.benefitId + '/' + this.selectedQuantity + '/' + this.get24PayMetaForTaxes()], {
        queryParams: { paymentType: this.selectedPaymentType }
      });
    } else {
      this._toastrService.error(
        this.t('FLEXIBLE_FIXED_BENEFITS.MESSAGES.PENDING_ORDER'),
        this.t('ERROR'),
        { toastClass: 'toast ngx-toastr', closeButton: true, timeOut: 3000 }
      );
    }
  }

  /**
   *  Helpers
   */

  private updateWorkingDay(
    days: number,
    setter: (newDate: number) => void
  ) {
    this.utilsService.getNthWorkingDay(days, new Date())
      .subscribe({
        next: response => {
          setter(new Date(response.responseObject).getDate());
        }
      });
  }

   // Shorthand for `this.translate.transform(...)` — keeps translation calls
   // concise and consistent across the component.
  private t(key: string, params?: Record<string, unknown>): string {
    return this.translate.transform(key, params);
  }

  get hasCamTax(): boolean {
    return (this.benefitTaxes?.camTaxValue ?? 0) > 0;
  }

  get camTaxTooltipKey(): string {
    return this.getCamTaxTooltipKey(this.benefitTaxes?.taxDistributionType);
  }

  get camTaxTooltipParams(): Record<string, number> {
    return { percentage: this.roundTaxPercentage(this.benefitTaxes?.camTaxPercentage ?? 0) };
  }

  private getCamTaxTooltipKey(taxDistributionType: number): string {
    if (taxDistributionType === CompanyTaxDistribution.EMPLOYEE) {
      return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_TAX_TOOLTIP_EMPLOYEE';
    }

    return 'BENEFIT_SUMMARY.SUMMARY_DETAILS.CAM_TAX_TOOLTIP_COMPANY_OR_SALARY';
  }

  private roundTaxPercentage(value: number): number {
    return Math.round(value * 100) / 100;
  }

  get amountWithCamTax(): number {
    return this.taxService.getAmountWithCam(this.benefitTaxes?.amountWithVat, this.benefitTaxes?.camTaxValue);
  }

  get amountWithEmployeeAndCamTax(): number {
    return this.taxService.getAmountToPayFromBenefitTaxes(this.benefitTaxes, CompanyTaxDistribution.EMPLOYEE);
  }

  readonly PricingPlan = PricingPlan;
  protected readonly PRICING_PLAN_LABEL = PRICING_PLAN_LABEL;

  protected readonly BenefitType = BenefitType;
}
